import '../initializers/autosize';
import '../initializers/rails-ujs';
import '../initializers/jquery-ui';
import '../initializers/object-fit-images';
import '../initializers/react-rails';

import './vendor';
import '../common';

import './chat/firebase/config';
import './chat/update-badges';
import './common/accordion-menu';
import './common/all-click-checkbox';
import './common/announcement';
import './common/async-load-css';
import './common/change-error-favicon-to-icon';
import './common/clipboard';
import './common/event-logger';
import './common/image-resize-square';
import './common/jquery-datetimepicker';
import './common/jquery-match-height';
import './common/jquery-toastr';
import './common/measure-clicks-with-google-analytics';
import './common/remain_toastr';
import './common/scrollTop-timeline';
import './common/sticky-sidebar';
import './common/temporary-image-uploader';
import './common/toggle';
import './common/ui-dialog--approvers';
import './common/ui-dialog--contact';
import './common/ui-dialog--google-auth-qr';
import './common/ui-dialog-logout';
import './common/ui-dialog-previous-copy';
import './common/ui-dialog-profile';
import './common/ui-dialog-sso';
import './feeds/must-read-feed';
import './home/sticky';
import './menus/applicable_number';
import './menus/details_accordion';
import './reports/items/document-uploader';
import './reports/items/image-selector';
import './reports/items/image-uploader';
import './reports/items/item-profile-image-uploader';
import './reports/items/poll_accepts_nested_attributes_for';
import './reports/items/profile';
import './reports/items/relay-user-select';
import './reports/items/select-users';
import './reports/items/video-uploader';
import './reports/form';
import './reports/preview-thanks-card';
import './reports/textarea-char-counter';
import './users/profile/sticky';
import './users/authentication-check';
import './users/search-users';
